import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import TableContainer from '../../common/Tablecontainer';

const TransactionReport = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [typeQuery, setTypeQuery] = useState('');
    const [filterType, setFilterType] = useState('All');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [tableKey, setTableKey] = useState(0);
    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);

    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);

    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 768
    );
        
    const handleFetchReportAction = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setLoading(true);
        try {
            console.log(filterType);

            const res = await API.get(`admin/comprehensive-transaction-report/`, {
                params: {
                    type: filterType,
                    fromDate: fromDate || '',
                    toDate: toDate || ''
                }
            });


            setTransactions(res.data.results);
            if (isMobile) {

                setMobilePage(1);

                loadTransactionReport(
                    1,
                    searchQuery
                );

            }

            setTableKey(prev => prev + 1);
        } catch (err) {
            console.error("API error:", err);
            toast.error("API failed.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {

        if (!isMobile) return;

        loadTransactionReport(1, searchQuery);

    }, []);

    useEffect(() => {

        if (!isMobile) return;

        const timer = setTimeout(() => {

            setMobilePage(1);

            loadTransactionReport(
                1,
                searchQuery
            );

        }, 400);

        return () => clearTimeout(timer);

    }, [
        searchQuery,
        filterType,
        fromDate,
        toDate
    ]);

    useEffect(() => {

        if (!isMobile) return;

        loadTransactionReport(
            mobilePage,
            searchQuery
        );

    }, [mobilePage]);
    useEffect(() => {

        const resize = () => {

            setIsMobile(window.innerWidth < 768);

        };

        window.addEventListener("resize", resize);

        return () =>
            window.removeEventListener("resize", resize);

    }, []);
    useEffect(() => {
        handleFetchReportAction();
    }, [filterType]);
    // useEffect(() => {
    //     handleFetchReportAction();
    // }, []);
    const loadTransactionReport = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "admin/comprehensive-transaction-report/",
                {
                    params: {
                        page,
                        search,
                        type: filterType,
                        fromDate,
                        toDate
                    }
                }
            );

            setList(res.data.results || []);

            setMobileTotalPages(
                Math.ceil((res.data.count || 0) / 10)
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };




    const tableHeaders = ['Date', 'Order ID', 'Customer Details Name', 'Course Name', 'Amount (INR)', 'Status Flag'];
    const handlePrintGridAction = () => {
        window.print();
    };
    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans print:p-0 select-none animate-fadeIn">
            <div className="w-full max-w-8xl mx-auto flex flex-col space-y-6 px-2">

                <div className="w-full text-center">
                    <h2 className="text-center text-4xl font-light text-gray-700 mb-4 tracking-tight">
                        Transaction Report
                    </h2>
                </div>

                {/* Filter Controls */}
                <form onSubmit={handleFetchReportAction} className="w-full bg-white border border-gray-300 px-6 pb-6 pt-2 rounded relative shadow-sm flex flex-col space-y-4 print:hidden">
                    <span className="absolute -top-2.5 left-4 bg-[#F8FAFC] px-2 text-[11px] font-bold text-gray-700 tracking-wide">
                        Transaction Report Filters
                    </span>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-xs font-bold uppercase text-gray-700 pt-4 w-full">
                        <div className="
                        flex
                        flex-col
                        md:flex-row
                        gap-2
                        ">
                            <label className="w-full md:w-[30%] md:text-right text-left  pr-2">Select Type(<span className="text-red-500">*</span>) :</label>
                            <select
                                className="flex-1 p-2 border border-gray-300 rounded-md outline-none bg-gray-50 font-bold text-[#032167] cursor-pointer h-9 shadow-sm"
                                value={filterType}
                                onChange={(e) => {setFilterType(e.target.value);
                            setTypeQuery(e.target.value);
                                }}
                            >
                            <option value="All">All Transactions</option>
                            <option value="SUCCESS">Success</option>
                            <option value="PENDING">Pending</option>
                            <option value="Failed">Failed</option>
                        </select>
                    </div>

                    <div className="flex items-center gap-2">
                        <label className="w-[30%] text-right pr-2">From Date:</label>
                        <input type="date" className="flex-1 p-2 border rounded-md h-9" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>

                    <div className="flex items-center gap-2">
                        <label className="w-[30%] text-right pr-2">To Date:</label>
                        <input type="date" className="flex-1 p-2 border rounded-md h-9" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>

                    {/* <button type="submit" className="px-8 py-2 bg-[#2563EB] text-white font-bold rounded-md hover:bg-blue-800 transition-all h-9">
                            Search
                        </button> */}
            </div>
            <div className="
            flex
            flex-col
            md:flex-row
            justify-center
            gap-3
            pt-4
            border-t
            ">
                <button
                    type="submit"
                    className="w-full md:w-auto px-12 py-2 bg-[#2563EB] text-white text-xs font-bold uppercase tracking-wider rounded-md hover:bg-blue-800 transition-all cursor-pointer border-none shadow-md active:scale-95"
                >
                    Search
                </button>
            </div>

        </form>

               {/* Datagrid Area */}
    
    <div className="w-full bg-white rounded-xl shadow-sm overflow-visible md:overflow-hidden border border-gray-200">
        
       
        {/* <div className="w-full p-2.5 bg-white border-b border-gray-300 flex justify-between items-center print:hidden">
            
            
            <div className="w-1/2">
               
            </div>

           
            <button 
                type="button"
                onClick={handlePrintGridAction}
                className="px-6 py-1.5 bg-[#2563EB] text-white font-semibold text-xs tracking-wide rounded hover:bg-blue-800 transition-colors cursor-pointer border-none shadow-md active:scale-95"
            >
                Print
            </button>
        </div> */}
        <div className="hidden md:block">
        <TableContainer
            columns={tableHeaders}
            key={tableKey}
            apiUrl="admin/comprehensive-transaction-report/"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            customActions={
                <button 
                    type="button"
                    onClick={handlePrintGridAction}
                    className="px-6 py-1.5 bg-[#2563EB] text-white font-semibold text-xs tracking-wide rounded hover:bg-blue-800 transition-colors cursor-pointer border-none shadow-md active:scale-95">
                    Print
                </button>
            }
            typeQuery={typeQuery}
            setTypeQuery={setTypeQuery}
            searchPlaceholder="Filter active transaction lists instantly..."
            renderRow={(tx, index, srNo) => (
                <tr key={tx.id || index} className="border-b hover:bg-gray-50/80 text-xs font-medium text-gray-700">
                    <td className="py-3 px-2 border-r bg-gray-50/30 text-center">{srNo}</td>
                    <td className="py-3 px-2 border-r text-center font-bold text-teal-600">{tx.date}</td>
                    <td className="py-3 px-2 border-r text-left pl-4 font-mono lowercase">{tx.order_id}</td>
                    <td className="py-3 px-2 border-r text-left pl-5 font-bold ">{tx.user_name}</td>
                    <td className="py-3 px-2 border-r text-left pl-4 font-bold text-[#032167]">{tx.course_names || "N/A"}</td>
                    <td className="py-3 px-2 border-r text-center font-bold text-blue-900">₹{parseFloat(tx.amount || 0).toFixed(2)}</td>

                    <td className="p-3 border-r text-center font-bold">
                        {tx.payment_status?.toUpperCase() === 'PENDING' ? (
                            <button
                                type="button"

                                onClick={async () => {
                                    const confirmApprove = window.confirm(`Confirm receipt for ${tx.user_name}?`);
                                    if (!confirmApprove) return;

                                    try {
                                        const token = localStorage.getItem('access_token');


                                        const [paymentId, courseId] = tx.id.split('_');

                                        const payload = {
                                            paymentdataid: paymentId,
                                            targetCourseId: courseId
                                        };

                                        const res = await API.post('admin/approve-pending-cash-transaction/', payload, {
                                            headers: { 'Authorization': `Bearer ${token}` }
                                        });

                                        if (res.status === 200) {
                                            toast.success("Success! Course Activated.");
                                            handleFetchReportAction();
                                        }
                                    } catch (err) {
                                        console.error("Approval Error:", err);
                                        toast.error("Approval failed!");
                                    }
                                }}
                                className="bg-yellow-100 text-yellow-800 border border-yellow-400 px-3 py-1 rounded text-[10px] font-bold uppercase tracking-wider animate-pulse"
                            >
                                PENDING
                            </button>
                        ) : (
                            <span className="bg-green-100 text-green-800 border border-green-400 px-3 py-1 rounded text-[10px] font-bold uppercase tracking-wider">
                                SUCCESS
                            </span>
                        )}
                    </td>
                </tr>
            )}
        />
        </div>
        <div className="md:hidden mt-4">

        <input
        type="text"
        value={searchQuery}
        onChange={(e)=>setSearchQuery(e.target.value)}
        placeholder="Search transaction..."
        className="
        w-full
        border
        rounded-lg
        p-3
        text-sm
        outline-none
        focus:border-blue-500
        "
        />

        </div>
        <div className="md:hidden space-y-4 mt-4">

        {
        loadingCards ?

        <div className="text-center py-10">

        Loading...

        </div>

        :

        list.length===0 ?

        <div className="text-center py-10">

        No Record Found

        </div>

        :

        list.map((tx)=>(

        <div
        key={tx.id}
        className="
        bg-white
        rounded-xl
        shadow-sm
        border
        p-4
        w-full
        max-w-full
        min-w-0
        overflow-hidden
        "
        >

        <div className="space-y-3">

        <div>

        <p className="text-xs text-gray-500">

        Date

        </p>

        <p>

        {tx.date}

        </p>

        </div>

        <div>

        <p className="text-xs text-gray-500">

        Order ID

        </p>

        <p className="break-all">

        {tx.order_id}

        </p>

        </div>

        <div>

        <p className="text-xs text-gray-500">

        Customer

        </p>

        <p>

        {tx.user_name}

        </p>

        </div>

        <div>

        <p className="text-xs text-gray-500">

        Course

        </p>

        <p>

        {tx.course_names}

        </p>

        </div>

        <div>

        <p className="text-xs text-gray-500">

        Amount

        </p>

        <p>

        ₹ {parseFloat(tx.amount||0).toFixed(2)}

        </p>

        </div>

        <div>

        <p className="text-xs text-gray-500">

        Status

        </p>

        {
        tx.payment_status==="PENDING"

        ?

        <button
        className="
        bg-yellow-100
        text-yellow-800
        px-3
        py-1
        rounded
        text-xs
        font-bold
        "
        onClick={()=>{
        /* pending approval logic */
        }}
        >

        PENDING

        </button>

        :

        <span
        className="
        bg-green-100
        text-green-800
        px-3
        py-1
        rounded
        text-xs
        font-bold
        "
        >

        SUCCESS

        </span>

        }

        </div>

        </div>

        </div>

        ))

        }

        </div>

        <div className="md:hidden flex justify-between items-center py-5">

            <button

            disabled={mobilePage===1}

            onClick={()=>setMobilePage(p=>p-1)}

            className="
            px-4
            py-2
            border
            rounded
            disabled:opacity-40
            "

            >

            Previous

            </button>

            <span>

            Page {mobilePage}

            of

            {mobileTotalPages}

            </span>

            <button

            disabled={mobilePage===mobileTotalPages}

            onClick={()=>setMobilePage(p=>p+1)}

            className="
            px-4
            py-2
            border
            rounded
            disabled:opacity-40
            "

            >

            Next

            </button>

            </div>
            </div>
            </div >
        </div >
    );
};

export default TransactionReport;